const storageBucket = process.env['VUE_APP_FIREBASE_STORAGE_BUCKET'];
export const parseGcsUrl = url =>
  url && url.startsWith('gcs:///')
    ? `https://firebasestorage.googleapis.com/v0/b/${storageBucket}/o/${encodeURIComponent(
        url.slice(7)
      )}?alt=media`
    : url;
export const parsedGcsUrlInMarkdown = markdownText =>
  markdownText.replace(
    /!\[([^\]]*)]\((gcs:\/\/\/.*)\)(\s|$)/g,
    (str, alt, url) => `![${alt}](${parseGcsUrl(url)})`
  );
